/**
 * **Oracle Micros**
 *
 * @exports bs_231
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * Forbid execution on mobile sites
       *
       * @memberOf module:bs_231
       * @see {@link allowed_location}
       *
       * @param {object} ctx - The context object.
       */
    engine.allowedLocation = function allowedLocation() {
        let isAllowedLocation = true;
        const mobileNavBarMenu = document.getElementById('nav-toggle');
        // Forbid hotel scripts exec on mobile sites
        if (window.location.pathname.match(/mobile/) || (mobileNavBarMenu && thn.isVisible(mobileNavBarMenu))) {
            isAllowedLocation = false;
        }
        return isAllowedLocation;
    };
    /**
       * @memberOf module:bs_231
       * @this thn.widgets.price
       * @see {@link Price#get_promocode}
       *
       * @param {object} ctx - The context object.
       */
    engine.getPromocode = function getPromocode(ctx) {
        const $ = window.jQuery;
        ctx.promocode = ($ && $('#discount-info p').text()) || undefined;
        return ctx.promocode;
    };
    /**
       * @memberOf module:bs_231
       * @see {@link is_user_logged}
       *
       * @param {object} ctx - The context object.
       */
    engine.isUserLogged = function isUserLogged(ctx) {
        return !!document.querySelector('.welcome-message');
    };
    /**
       * @memberOf module:bs_231
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        /* Mobile site is not done because they didn't have any available info in the R&R page, just the price.. */
        const widgetData = {};
        const $ = window.jQuery;
        if (!$) {
            return widgetData;
        }
        // Dates
        const dateBegin = ((document.querySelector('#check-in') || {}).value || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');
        const dateEnd = ((document.querySelector('#check-out') || {}).value || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
        }
        // Guests, Adults & Children
        widgetData.adults = parseInt($('#numberOfAdults').val(), 10) || 2;
        widgetData.children = parseInt($('#numberOfChildren').val(), 10) || 0;
        widgetData.guests = widgetData.adults + widgetData.children;
        const rateBlacklist = {
            // Margaritaville Hollywood Beach Resort
            1015913: ['AAA', 'AARP', 'FLRES', 'GOVT'],
        };
        const propertyHasRateExceptions = !!(rateBlacklist[thn.data.propertyId]);
        // Prices & Currency || No Rooms
        const prices = $('.converted_currency_amount').map(function (idx, priceEl) {
            if (propertyHasRateExceptions) {
                let roomRate = priceEl.closest('.room-types[id]');
                roomRate = roomRate && roomRate.getAttribute('id');
                roomRate = (roomRate.indexOf('room-rate') === 0) ? roomRate.substr(9) : roomRate;
                if (roomRate && rateBlacklist[thn.data.propertyId].some(function (pattern) { return !!roomRate.match(new RegExp(pattern)); })) {
                    return null;
                }
            }
            return thn.parseNumber(priceEl.textContent);
        });
        const currency = (document.querySelector('.currency-code') || {}).textContent || '';
        if (prices.length) {
            widgetData.price = Math.min(...prices);
            widgetData.currency = (currency && thn.parseCurrency(currency)) || 'USD';
            widgetData.set = true;
        }
        else if ($('#no-results-msg').length) {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_231
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        // Booking ID
        widgetData.bookingId = thn.dataLayerHelper.get('transactionId') || (document.querySelector('.your-reservation__additional-details') || {}).getAttribute('data-conf') || '';
        // Dates
        const dates = ((document.querySelector('.your-reservation__dates-details') || {}).textContent || '').match(/(\d+)\D+(\d+)\D+(\d+)/g);
        if (dates && dates.length > 1) {
            widgetData.dateBegin = dates[0].replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');
            widgetData.dateEnd = dates[1].replace(/-/g, '/').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');
        }
        // Price & Currency
        widgetData.price = thn.parseNumber((document.querySelector('.guest_info__total_price') || {}).textContent || '');
        widgetData.currency = thn.parseCurrency((document.querySelector('.currency-code') || {}).textContent) || 'USD';
        return widgetData;
    };
    return engine;
}

export { factory };
